import React from 'react';
import { ShieldOff } from 'lucide-react';

interface ProtectedViewProps {
  children: React.ReactNode;
  hasPermission: boolean;
  message?: string;
}

/**
 * Wrapper component to protect views based on user permissions
 * Shows access denied message if user doesn't have permission
 */
const ProtectedView: React.FC<ProtectedViewProps> = ({ 
  children, 
  hasPermission, 
  message = 'No tienes permisos para acceder a esta sección.' 
}) => {
  if (!hasPermission) {
    return (
      <div className="flex items-center justify-center min-h-[400px] bg-slate-900 rounded-lg">
        <div className="text-center p-8">
          <div className="w-20 h-20 bg-red-500/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <ShieldOff className="w-10 h-10 text-red-400" />
          </div>
          <h2 className="text-2xl font-bold text-white mb-2">Acceso Denegado</h2>
          <p className="text-slate-400 max-w-md">{message}</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedView;
